'use strict';
import SxQueryUtils from '../../sxQuery/SxQueryUtils';
import BlockEntryType from '../enums/BlockEntryType';
import SuggestionBlock from '../ui/SuggestionBlock';
var createEmptyBlock = function (context, source) { return new SuggestionBlock({
    type: source.type,
    data: []
}, source.layout, [], source.categoryStyle, context.pluginConfiguration.suggestions, source.style); };
var generateId = function (type) { return type + "_" + Math.round(Math.random() * 100000); };
var loadResultGroup = function (context, suggestionUrl, query, source, callback, skipSuggestions) {
    if (skipSuggestions === void 0) { skipSuggestions = false; }
    if (source.query !== undefined) {
        query = source.query;
    }
    var exclude = [];
    var include = [];
    var maxQuerySuggestions = 0;
    var ignoreOther = false;
    if (source.value !== undefined && source.value.length > 0) {
        include.push(source.value);
    }
    else {
        var contentGroups = context.pluginConfiguration.contentGroups;
        exclude = contentGroups.exclude;
        include = contentGroups.include;
        ignoreOther = contentGroups.ignoreOther;
        var maxSuggestions_1 = context.pluginConfiguration.suggestions.maxSuggestions;
        if (Object.keys(maxSuggestions_1).length > 0) {
            include = Object.keys(maxSuggestions_1).map(function (key) { return key + "#" + maxSuggestions_1[key]; });
        }
        maxQuerySuggestions = context.pluginConfiguration.suggestions.maxQuerySuggestions;
    }
    if (skipSuggestions) {
        maxQuerySuggestions = 0;
    }
    if (include !== undefined) {
        suggestionUrl += "&includeContentGroups=" + encodeURIComponent(JSON.stringify(include));
    }
    if (exclude !== undefined || ignoreOther) {
        if (exclude === undefined) {
            exclude = [];
        }
        if (ignoreOther && exclude.indexOf('_') === -1) {
            exclude.push('_');
        }
        suggestionUrl += "&excludeContentGroups=" + encodeURIComponent(JSON.stringify(exclude));
    }
    if (maxQuerySuggestions > 0) {
        suggestionUrl += "&maxQuerySuggestions=" + maxQuerySuggestions;
    }
    var num = source.limit !== undefined ? source.limit : context.pluginConfiguration.suggestions.num;
    if (num !== null) {
        suggestionUrl = suggestionUrl + "&limit=" + num;
        if (source.value === 'ss360QuerySuggestions') {
            suggestionUrl = suggestionUrl + "&maxQuerySuggestions=" + num;
        }
    }
    SxQueryUtils.get(suggestionUrl + "&query=" + encodeURIComponent(query), function (data) {
        if (data !== undefined && data.suggests === undefined && data.searchResults !== undefined) { // product search fallback
            data.suggests = data.searchResults.reduce(function (acc, entry) {
                acc[entry.name] = entry.results;
                return acc;
            }, {});
        }
        var dataSet = Object.keys(data.suggests).reduce(function (acc, key) {
            data.suggests[key].forEach(function (entry) {
                var firstEntry;
                if (entry instanceof Array) {
                    firstEntry = entry[0];
                }
                else {
                    firstEntry = entry;
                }
                acc.push({
                    image: firstEntry.image,
                    title: firstEntry.name,
                    link: firstEntry.link,
                    snippet: firstEntry.content,
                    contentGroup: key,
                    id: generateId('resultGroup'),
                    dataPoints: firstEntry.dataPoints,
                    identifier: firstEntry.identifier,
                    suggestionHtml: firstEntry.suggestionHtml
                });
            });
            return acc;
        }, []);
        callback(new SuggestionBlock({
            type: source.type,
            data: dataSet,
            plan: data.plan,
            attribution: data.attribution
        }, source.layout, source.dataPoints, source.categoryStyle, context.pluginConfiguration.suggestions, source.style));
    }, function () {
        callback(createEmptyBlock(context, source));
    }, 'json', false);
};
var loadSearchHistory = function (context, source, callback) {
    // @ts-ignore
    var data = context.readObject('unibox_search_history', []).map(function (entry) { return ({
        title: entry,
        id: generateId('history')
    }); });
    callback(new SuggestionBlock({
        type: source.type,
        data: data
    }, source.layout, source.dataPoints, source.categoryStyle, context.pluginConfiguration.suggestions, source.style));
};
var loadDataSet = function (context, source, callback) {
    callback(new SuggestionBlock({
        type: source.type,
        data: source.content || []
    }, source.layout, source.dataPoints, source.categoryStyle, context.pluginConfiguration.suggestions, source.style));
};
var loadSource = function (context, suggestionUrl, query, source, callback, skipSuggestions) {
    if (skipSuggestions === void 0) { skipSuggestions = false; }
    if (source.type === BlockEntryType.ResultGroup) {
        loadResultGroup(context, suggestionUrl, query, source, callback, skipSuggestions);
    }
    else if (source.type === BlockEntryType.SearchHistory) {
        loadSearchHistory(context, source, callback);
    }
    else if (source.type === BlockEntryType.DataSet) {
        loadDataSet(context, source, callback);
    }
    else if (source.type === BlockEntryType.Empty) {
        var block = createEmptyBlock(context, source);
        block.setEmpty(true);
        callback(block);
    }
    else {
        console.warn('Source', source.type, 'not supported yet');
        callback(createEmptyBlock(context, source));
    }
};
export default {
    load: function (context, suggestionUrl, query, sources, callback) {
        var blocks = new Array(sources.length);
        var loaded = 0;
        var skipSuggestions = sources.reduce(function (acc, source) { return acc || (source.type === BlockEntryType.ResultGroup && source.value === 'ss360QuerySuggestions'); }, false);
        sources.forEach(function (source, idx) {
            loadSource(context, suggestionUrl, query, source, function (block) {
                blocks[idx] = block;
                loaded++;
                if (loaded === sources.length) {
                    callback(blocks);
                }
            }, skipSuggestions && source.value !== 'ss360QuerySuggestions');
        });
    }
};
